if (!customElements.get('ukl-neon-cut-family')) {
  customElements.define('ukl-neon-cut-family', class extends HTMLElement {
    connectedCallback() {
      if (this.initialised) return;
      this.initialised = true;
      this.link = this.querySelector('[data-ukl-cut-link]');
      this.unavailable = this.querySelector('[data-ukl-cut-unavailable]');
      if (!this.link) return;
      try {
        this.data = JSON.parse(this.querySelector('[data-ukl-cut-data]').textContent);
      } catch (error) {
        this.setUnavailable();
        return;
      }
      this.refresh = this.refresh.bind(this);
      window.addEventListener('pageshow', this.refresh);
      this.bindPicker();
    }

    disconnectedCallback() {
      this.picker?.removeEventListener('on:variant:change', this.refresh);
      this.picker?.removeEventListener('change', this.refresh);
      window.removeEventListener('pageshow', this.refresh);
      this.initialised = false;
    }

    setUnavailable() {
      this.link?.removeAttribute('href');
      this.link?.setAttribute('aria-disabled', 'true');
      if (this.unavailable) this.unavailable.hidden = false;
    }

    bindPicker(attempt = 0) {
      if (!this.isConnected) return;
      this.picker = this.closest('.product-options')?.querySelector('variant-picker');
      if (!this.picker && attempt < 60) {
        requestAnimationFrame(() => this.bindPicker(attempt + 1));
        return;
      }
      this.picker?.addEventListener('on:variant:change', this.refresh);
      this.picker?.addEventListener('change', this.refresh);
      this.refresh();
    }

    refresh() {
      const checked = this.picker?.querySelector('input[type="radio"]:checked');
      const selected = this.picker?.querySelector('select')?.value;
      const selectedValue = checked?.value || selected;
      if (!this.data?.valid || !selectedValue || !Array.isArray(this.data.target)) {
        this.setUnavailable();
        return;
      }
      const target = this.data.target.filter((item) => Array.isArray(item.options) && item.options.length === 1 && item.options[0] === selectedValue);
      if (target.length !== 1 || !/^\d+$/.test(target[0].id)) {
        this.setUnavailable();
        return;
      }
      const url = new URL(this.data.path, window.location.origin);
      if (url.origin !== window.location.origin || !url.pathname.includes('/products/')) {
        this.setUnavailable();
        return;
      }
      url.searchParams.set('variant', target[0].id);
      const previewThemeId = new URL(window.location.href).searchParams.get('preview_theme_id');
      if (previewThemeId && /^\d+$/.test(previewThemeId)) url.searchParams.set('preview_theme_id', previewThemeId);
      this.link.href = url.pathname + url.search;
      this.link.removeAttribute('aria-disabled');
      if (this.unavailable) this.unavailable.hidden = true;
    }
  });
}
